"use strict";
/**
 * @module "ethpm/installer/truffle"
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TruffleService = void 0;
const fs = require('fs-extra');
const tmp = require('tmp');
const path = require('path');
const ipfs_1 = require("../../storage/ipfs");
const resolver_1 = require("../../package/resolver");
const config = __importStar(require("../../config"));
const t = __importStar(require("io-ts"));
class TruffleService {
    constructor(options) {
        this.workingDir = options.workingDirectory;
        this.ethpmDir = path.join(this.workingDir, "_ethpm_packages");
        this.lockfilePath = path.join(this.ethpmDir, "ethpm.lock");
        this.ipfsOptions = options.ipfs;
        this.resolver = new resolver_1.Resolver(new ipfs_1.IpfsService(this.ipfsOptions));
        // assumes if ethpmDir exists - it is correctly formatted
        if (!fs.existsSync(this.ethpmDir)) {
            fs.mkdirSync(this.ethpmDir);
            fs.writeFileSync(this.lockfilePath, "{}");
        }
    }
    install(contentURI, registryAddress, alias) {
        return __awaiter(this, void 0, void 0, function* () {
            // create temporary _ethpm_packages/
            const tmpEthpmDir = tmp.dirSync({ unsafeCleanup: true });
            fs.copySync(this.ethpmDir, tmpEthpmDir.name);
            const tmpLockfilePath = path.join(tmpEthpmDir.name, "ethpm.lock");
            const pkg = yield this.resolver.resolve(contentURI);
            //
            // check for conflicts
            //
            const packageAlias = (typeof alias != "undefined") ? alias : pkg.originalPackage.packageName;
            const newPackageDir = path.join(tmpEthpmDir.name, packageAlias);
            if (fs.existsSync(newPackageDir)) {
                throw new Error("Package: " + packageAlias + " already installed. Try using an alias.");
            }
            else {
                fs.mkdirSync(newPackageDir);
            }
            const manifestPath = path.join(newPackageDir, "manifest.json");
            fs.writeFileSync(manifestPath, pkg.rawManifest);
            //
            // update ethpm.lock
            //
            const lockfileData = {
                [packageAlias]: {
                    alias: packageAlias,
                    install_uri: contentURI.href,
                    registry_address: registryAddress,
                    resolved_content_hash: contentURI.host,
                    resolved_package_name: pkg.originalPackage.packageName,
                    resolved_uri: contentURI.href,
                    resolved_version: pkg.originalPackage.version
                }
            };
            if (!fs.existsSync(tmpLockfilePath)) {
                fs.writeFileSync(tmpLockfilePath, JSON.stringify(lockfileData, null, 4) + "\n");
            }
            else {
                const existingLockfileData = JSON.parse(fs.readFileSync(tmpLockfilePath));
                const updatedLockfileData = Object.assign(existingLockfileData, lockfileData);
                const ordered = {};
                Object.keys(updatedLockfileData).sort().forEach((key) => {
                    ordered[key] = updatedLockfileData[key];
                });
                fs.writeFileSync(tmpLockfilePath, JSON.stringify(ordered, null, 4) + "\n");
            }
            //
            // write sources to tmpEthpmDir
            //
            if (Object.entries(pkg.sources).length !== 0) {
                const sourcesDir = path.join(newPackageDir, "_src");
                fs.mkdirSync(sourcesDir);
                Object.entries(pkg.sources).forEach(([pth, sourceObject], idx) => {
                    const targetPath = path.join(sourcesDir, path.normalize(pth));
                    const targetDir = path.parse(targetPath).dir;
                    if (!fs.existsSync(targetDir)) {
                        fs.mkdirSync(targetDir, { recursive: true });
                    }
                    fs.writeFileSync(targetPath, sourceObject['content']);
                });
            }
            //
            // write build dependencies to tmpEthpmDir
            //
            if (Object.entries(pkg.buildDependencies).length !== 0) {
                const buildDependenciesInstaller = new TruffleService({ workingDirectory: newPackageDir, ipfs: this.ipfsOptions });
                for (const [name, dependencyURI] of Object.entries(pkg.originalPackage.buildDependencies)) {
                    yield buildDependenciesInstaller.install(dependencyURI, registryAddress);
                }
            }
            //
            // copy tmpEthpmDir to disk
            //
            fs.copySync(tmpEthpmDir.name, this.ethpmDir);
            tmpEthpmDir.removeCallback();
        });
    }
}
exports.TruffleService = TruffleService;
class TruffleConnector extends config.Connector {
    constructor() {
        super(...arguments);
        this.optionsType = t.interface({
            workingDirectory: t.string,
            ipfs: t.interface({
                host: t.string,
                port: t.union([t.number, t.string]),
                protocol: t.string,
            })
        });
    }
    init(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const service = new TruffleService(options);
            return service;
        });
    }
}
exports.default = TruffleConnector;
